import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { EvseOrderState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOrderStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Order')



const statusLabel = computed(() => {
  switch (props.state) {
    case EvseOrderState.EOS_INIT: // 0 初始下单
      return tl('chargeStateInit')
    case EvseOrderState.EOS_PENDING: // 10 启动指令已下发，订单等待处理
      return tl('chargeStatePending')
    case EvseOrderState.EOS_RESERVER: // 20 预约成功
      return tl('chargeStateReserver')
    case EvseOrderState.EOS_REMOTE_STARTED: // 30 启动充电成功，等待连接
      return tl('chargeStateRemoteStarted')
    case EvseOrderState.EOS_CHARGING: // 50 连接成功，充电中
      return tl('chargeStateCharging')
    case EvseOrderState.EOS_REMOTE_STOPPED: // 70 Deprecated 废弃这两状态，没有必要
      return tl('chargeStateRemoteStopped')
    case EvseOrderState.EOS_STOPPED: // 90 结束充电成功，等待计费结果
      return tl('chargeStateRemoteStopped')
    case EvseOrderState.EOS_FINISH: // 100 充电完成
      return tl('chargeStateFinish')

    case EvseOrderState.EOS_REMOTE_START_REJECT: // 11 设备拒绝启动充电（马上退款）
      return tl('chargeStateRemoteStartReject')
    case EvseOrderState.EOS_REMOTE_START_TIMEOUT: // 12 启动充电超时（马上退款）
      return tl('chargeStateRemoteStartTimeout')
    case EvseOrderState.EOS_REMOTE_START_FAIL: // 14 启动充电失败，后台导致的（马上退款）
      return tl('chargeStateRemoteStartFail')
    case EvseOrderState.EOS_RESERVER_EXPIRES: // 21
      return tl('chargeStateReserverExpires')
    case EvseOrderState.EOS_RESERVER_CANCEL: // 22
      return tl('chargeStateReserverCancel')
    case EvseOrderState.EOS_COST_CONFLICT: // 91 费用冲突
      return tl('chargeStateCostConflict')
    case EvseOrderState.EOS_REMOTE_STOP_TIMEOUT: // 71 结束充电超时
    case EvseOrderState.EOS_CONNECTOR_DIFF_SESSION_SUSPEND: // 51 枪头的订单会话不一致导致挂起
      return tl('chargeStateConnectorDiffSessionSuspend')
    case EvseOrderState.EOS_CONNECTOR_AVAILABLE_SUSPEND: // 52 枪头空闲可用导致订单挂起
      return tl('chargeStateConnectorAvailableSuspend')
    case EvseOrderState.EOS_CONNECTOR_FAULT_SUSPEND: // 53 枪头故障导致订单挂起
      return tl('chargeStateConnectorFaultSuspend')
    case EvseOrderState.EOS_CONNECTOR_OFFLINE_SUSPEND: // 54 枪头离线导致订单挂起
      return tl('chargeStateConnectorOfflineSuspend')
    case EvseOrderState.EOS_DEAD: // 55 长时间不活跃，订单挂起
      return tl('chargeStateDead')
    case EvseOrderState.EOS_CONNECT_TIMEOUT: // 31 连接超时（3天内退款）
      return tl('chargeStateConnectTimeout')
    case EvseOrderState.EOS_CONNECTOR_UNAVAILABLE_SUSPEND: // 32 枪头不可用导致订单挂起
      return tl('chargeStateConnectorUnavailableSuspend')
  }
  return 'Unknown'
})

const statusTips = computed(() => {
  return tl('chargingState')
})

const color = computed(() => {
  switch (props.state) {
    case (EvseOrderState.EOS_REMOTE_START_REJECT, // 11 设备拒绝启动充电（马上退款）
    EvseOrderState.EOS_REMOTE_START_TIMEOUT, // 12 启动充电超时（马上退款）
    EvseOrderState.EOS_REMOTE_START_FAIL, // 14 启动充电失败，后台导致的（马上退款）
    EvseOrderState.EOS_COST_CONFLICT, // 91 费用冲突
    EvseOrderState.EOS_REMOTE_STOP_TIMEOUT, // 71 结束充电超时
    EvseOrderState.EOS_CONNECTOR_DIFF_SESSION_SUSPEND, // 51 枪头的订单会话不一致导致挂起
    EvseOrderState.EOS_CONNECTOR_AVAILABLE_SUSPEND, // 52 枪头空闲可用导致订单挂起
    EvseOrderState.EOS_CONNECTOR_FAULT_SUSPEND, // 53 枪头故障导致订单挂起
    EvseOrderState.EOS_CONNECTOR_OFFLINE_SUSPEND, // 54 枪头离线导致订单挂起
    EvseOrderState.EOS_DEAD, // 55 长时间不活跃，订单挂起
    EvseOrderState.EOS_CONNECT_TIMEOUT, // 31 连接超时（3天内退款）
    EvseOrderState.EOS_CONNECTOR_UNAVAILABLE_SUSPEND): // 32 枪头不可用导致订单挂起
      return '#EB4E3D'

    // case EvseOrderState.EOS_FINISH: // 100 充电完成
    //   return '#00B173'
  }
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    content: _unref(statusTips)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "text-status",
        style: _normalizeStyle({ color: _unref(color) })
      }, _toDisplayString(_unref(statusLabel)), 5)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})